import BookingForm from "../forms/BookingForm";

export default function BookingPage({ availableTimes, dispatch, submitForm }) {
  return (
    <>
      <section id="booking">
        <div className="container grid">
          {/* Header */}
          <div id="booking-header">
            <h1 style={{ textAlign: "center" }}>Reserve a Table</h1>
          </div>

          {/* Form */}
          <div
            id="booking-form"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <BookingForm
              availableTimes={availableTimes}
              dispatch={dispatch}
              submitForm={submitForm}
            />
          </div>
        </div>
      </section>
    </>
  );
}
